import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root',
})
export class ScreenCaptureService {
  constructor() {}
  screenCapture(id: string, filename: string) {
    try {
      const element = document.querySelector('#' + id)!;

      //html2canvas(element).then((canvas) => {
      html2canvas(element as HTMLElement).then((canvas) => {
          //document.body.appendChild(canvas)
        // canvas is the canvas object that represents the screenshot
        const dataUrl = canvas.toDataURL();
        this.downloadImage(dataUrl, filename);
      });
    } catch (error: any) {
      alert('capture error:' + error.message);
    }
  }
  downloadImage(dataUrl:string, filename: string) {
    const link = document.createElement('a');
    link.download = filename;
    link.href = dataUrl;
    link.click();
  }
}
